import ResetPassPage from './ResetPassPage';

export default ResetPassPage;
